/*
 * @Author: lbh
 * @Date: 2020-12-24 18:12:01
 * @LastEditors: lbh
 * @LastEditTime: 2025-08-21 17:26:13
 * @Description: file content
 */
// 導入 vue 框架
// import Vue from "vue";
import axios from "axios";
import qs from "qs";
import MobileDetect from "mobile-detect";
import util from "./util";
import setting from "../../../package.json";
import logan from "./logan";
import { lodash } from "./lodash";
import i18n from "@/i18n";
axios.defaults.timeout = 15000;
// Vue.prototype.axios = axios;
// axios.defaults.timeout = 15000;

const limitRequestUrl = [
  "/ricepon-support/api/public/addClickHead",
  "/ricepon-system/api/public/country/list",
  "/ricepon-system/api/public/memberSetting/get",
  "/ricepon-restaurant/api/brand/getSeo",
];

// 請求攔截
axios.interceptors.request.use(
  (config) => {
    // 校驗 apptype
    if (
      config.url.indexOf("public/sms/login") > -1 ||
      config.url.indexOf("public/register") > -1
    ) {
      delete config.headers.apptype;
      config.headers.apptype = 7;
    }
    if (!config.url.includes("addClickHead")) {
      if (config.params && config.params.appType) {
        config.headers.apptype = config.params.appType;
        delete config.params.appType;
      }
      if (config.data && config.data.appType) {
        config.headers.apptype = config.data.appType;
        delete config.data.appType;
      }
    }
    if (config.data && config.data.isAppInfo) {
      config.headers.appinfo = config.data.isAppInfo;
      delete config.data.isAppInfo;
    }
    if (config.data && config.data.token) {
      config.headers.token = config.data.token;
      delete config.data.token;
    }
    let contentType =
      config.headers["Content-Type"] ||
      config.headers["Content-type"] ||
      config.headers["content-type"] ||
      config.headers["content-Type"];
    if (
      config.method == "post" &&
      contentType.indexOf("application/x-www-form") > -1 &&
      config.url.indexOf("aliyuncs.com") == -1
    )
      config.data = qs.stringify(config.data);
    let url = config.url.split(location.origin)[1];
    if (!limitRequestUrl.includes(url)) {
      logan.log(config, logan.types.request);
    }
    // openapi 處理
    if (config.url.includes("ricepon-external")) {
      let headers = config.headers;
      let key =
        "apptype,appType,appVersion,mobileModel,mobileToken,mobileVersion,product,secretKey,token,ver,version,Content-Type,Content-type,content-type,content-Type";
      let keys = key.split(",");
      for (let i in headers) {
        if (!keys.includes(i)) {
          delete headers[i];
        }
      }
      config.headers = headers;
    }

    config.headers.languageId = i18n.getLanguageId();

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 響應 攔截
axios.interceptors.response.use(
  (response) => {
    try {
      let config = response.config || "";
      let url = config.url || "";
      let split = url.split(location.origin) || [];
      url = split[1];
      if (!limitRequestUrl.includes(url)) {
        let responseCopy = lodash.clone(response);
        Promise.resolve().then(() => {
          logan.log(responseCopy, logan.types.response);
        });
      }
    } catch (error) {
      console.error("Log error:", error);
    }
    if (response.status == 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error.response.status) {
      return Promise.reject(error.response);
    }
  }
);

// ? 獲取 appType
const getAppType = () => {
  let appType = 7;
  // * 判斷是否是微信, 且需要是特定頁面
  // * 如果是 微信, 則apptype 設置為 4
  const isWeChat =
    /MicroMessenger/i.test(navigator.userAgent) || // 移动端微信
    /WindowsWechat/i.test(navigator.userAgent); // PC端微信
  const routerArr = ["/callNumber/", "/callNumberDetail/"];
  // * 判断 location.href 中是否包含了 routerArr 中的任意一个
  const isRouter = routerArr.some((router) => location.href.includes(router));
  if (isWeChat && isRouter) {
    appType = 4;
  }

  // * 判斷是否是自主埋單機 自主埋單機的路由, 需要包含 kiosk
  const kioskRouter = ["/kiosk"];
  const isKiosk = kioskRouter.some((router) => location.href.includes(router));
  if (isKiosk) {
    appType = 70;
  }
  return appType;
};

var https = {
  host() {
    return process.env.VUE_APP_BASE_URL;
  },
  /**
   * 獲取 頭部信息
   */
  setHeaders(object) {
    var md = new MobileDetect(window.navigator.userAgent);
    let mt = util.getToken();
    let contentType = "";
    if (typeof object == "object") {
      if (object.contentType) contentType = object.contentType;
    } else contentType = object;
    let appType = getAppType();
    var headers = {
      "Content-type":
        contentType || "application/x-www-form-urlencoded;charset=UTF-8",
      mobileToken: mt, // 用戶標識
      apptype: appType, // 新接口
      version: "n-h5", // 表示是 新h5
      appVersion: setting.version, // Vue.prototype.appVersion, // 程序版本號
      mobileModel: md.os(), // 系统 如 ios
      mobileVersion: md.os() + md.version(md.userAgent()), // 系统版本  如 ios11
      secretKey: "2309485937845783",
      product: md.mobile(), // 手机型号(名称)
      ver: md.os() + md.version(md.userAgent()), // 系统版本  如 ios11
      token: util.token.get(),
    };
    // if (type) headers["Content-type"] = type;
    if (typeof object == "object") {
      if (object.origin) headers["Access-Control-Allow-Origin"] = "*";
      if (object.token) headers["token"] = object.token;
      if (object.appType) {
        delete headers.apptype;
        headers["appType"] = object.appType;
      }
      if (object.Referer) headers["Referer"] = object.Referer;
    }
    return headers;
  },
  /**
   * get 請求
   * @param {string} url
   * @param {object} params
   */
  get(url, params, h) {
    return axios
      .get(url, {
        headers: this.setHeaders(h),
        params: params,
      })
      .then((res) => res.data)
      .catch((err) => err.data);
  },
  /**
   * post 請求
   * @param {string} url
   * @param {object} params
   */
  post(url, params, h = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, {
          headers: this.setHeaders(h),
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  },
  /**
   * form 表单提交
   * @param {*} url
   * @param {*} params
   * @returns
   */
  form(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, {
          headers: this.setHeaders("multipart/form-data"),
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  },
  /**
   * body
   * @param {*} url
   * @param {*} params
   * @returns
   */
  body(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, {
          headers: this.setHeaders("application/json"),
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  },
  /**
   * 圖片上傳
   * @param {*} url
   * @param {*} params
   * @returns
   */
  upload(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, {
          headers: this.setHeaders({
            origin: "*",
          }),
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  },
};
export default https;
